import clsxm from "immigram-ui-cmon/src/lib/clsxm";
import { ChangeEvent, useState } from "react";
import TextareaAutosize from "react-textarea-autosize";

import Button from "../Button/Button";

interface IInputChatProps {
  value: string;
  placeholder: string;
  disabled?: boolean;
  autoFocus?: boolean;
  onSave: (value: string) => void;
}

function InputChat(props: IInputChatProps) {
  const [value, setValue] = useState(props.value);
  const [focus, setFocus] = useState(false);

  function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
    setValue(event.target.value);
  }

  return (
    <div
      className={clsxm(
        "relative flex w-full items-end overflow-hidden rounded-2xl px-1 pt-1",
        "border border-solid border-gray-150 bg-gray-150 placeholder-black-400 transition",
        "hover:bg-gray-150 focus:border-gray-150 ",
        focus ? "bg-white-900 hover:bg-white-900" : "bg-gray-100",
        props.disabled
          ? "cursor-default text-black-400"
          : "cursor-pointer text-black-900",
        !focus && "hover:cursor-pointer"
      )}
      onClick={(event) => event.stopPropagation()}
    >
      <TextareaAutosize
        value={value}
        minRows={1}
        className="w-full resize-none border-0 bg-inherit focus:outline-none focus:ring-0"
        placeholder={focus || value.length > 0 ? props.placeholder : undefined}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        onChange={handleChange}
        autoFocus={props.autoFocus}
      />
      <div className="mb-[5px] mr-[5x] max-h-8 ">
        <Button
          disabled={!value}
          onClick={() => props.onSave(value)}
          size="200"
        >
          Send
        </Button>
      </div>
    </div>
  );
}

export default InputChat;
